/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Plus_Content_TitleInputs */

const en_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seasonal New Trees + Sounds`)
};

const ar_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار جديدة موسمية + أصوات`)
};

const de_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisonale neue Bäume + Klänge`)
};

const es_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos árboles de temporada + Sonidos`)
};

const fr_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveaux arbres et sons saisonniers`)
};

const it_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovi alberi stagionali + suoni`)
};

const ja_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズンごとの新しい木やサウンド`)
};

const ko_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시즌별 신규 나무 + 사운드`)
};

const pt_br_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novas árvores + sons da temporada`)
};

const ru_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые сезонные деревья + звуки`)
};

const th_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ใหม่ + เสียงตามฤดูกาล`)
};

const tr_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevsimsel Yeni Ağaçlar + Sesler`)
};

const zh_cn_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当季新树种 + 声音`)
};

const zh_tw_subscription_service_level_compare_plus_content_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plus_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`當季新樹種+聲音`)
};

/**
* | output |
* | --- |
* | "Seasonal New Trees + Sounds" |
*
* @param {Subscription_Service_Level_Compare_Plus_Content_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_plus_content_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Plus_Content_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Plus_Content_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_plus_content_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_plus_content_title(inputs)
	return zh_tw_subscription_service_level_compare_plus_content_title(inputs)
});